import { IHotelSelectOption } from '../../app/common/hooks/useSearchHotel';

export const filterHotelOptions = (
  value: string,
  options: IHotelSelectOption[]
) => {
  if (value) {
    const filtered = options.filter((option) =>
      option.text.toLowerCase().includes(value.toLowerCase())
    );
    return filtered;
  } else {
    return [];
  }
};

export const handleHotelOptionSelection = (
  selected: IHotelSelectOption,
  selectedOptions: IHotelSelectOption[]
) => {
  if (!selectedOptions.some((option) => option.id === selected.id)) {
    return [
      {
        id: selected.id,
        text: selected.text,
        locationId: selected.locationId,
      },
    ];
  }
  return [];
};
